import { render, staticRenderFns } from "./ProductVideoSettings.vue?vue&type=template&id=5f54f1d4"
import script from "./ProductVideoSettings.vue?vue&type=script&lang=js"
export * from "./ProductVideoSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports